import React from 'react'
import { Modal } from 'react-bootstrap';
import { IoMdCloseCircleOutline } from "react-icons/io";
const ImageModal = (props) => {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className='image-modal'
            fullscreen={true}
        >
            <Modal.Body>
                <IoMdCloseCircleOutline onClick={props.onHide} className='image-modal-close-icon' />
                <img src={props?.imageData} alt="" />
            </Modal.Body>
        </Modal>
    );
}

export default ImageModal;